// extracted by css-extract-rspack-plugin
export default {"cls1":"NameList-cls1_8Om","cls2":"NameList-cls2_Kz6 NameList-cls1_8Om"};